import React from 'react';
import GeneralContactForm from './GeneralContactForm';
import fountain from '../images/fountain.jpg';
import hug from '../images/hug.jpg';
import header_two_ham from '../images/header_two_ham.jpg';
import Helmet from "react-helmet";
import main from '../images/main1.jpg';

const Evaluation = () => (
  <div className="full-job-ctn">
    <Helmet>
      <title>Hamilton Homes - Evaluation</title>
      <meta name="description" content="We simplify your selling processes, and with our expertise, make sure you get what you want for the price you ask!"/>
      <meta name="keywords" content="selling,hamilton,home,evaluation,homes,for,sale,niburski,search,condos,luxury,business"/>

      <meta property="og:url" content="https://besthamiltonhouses.com/evaluation"/>
      <meta property="og:title" content="Hamilton Homes - Evaluate your Home"/>
      <meta property="og:description" content="We simplify your selling processes, and with our expertise, make sure you get what you want for the price you ask!"/>
    </Helmet>

    <div className="job-outline">
      <div className="full-job-details-stacked listing-page buy-page">
        <div className="heading">
          <h2>Get Your Home Evaluated In Minutes!</h2>
        </div>

        <div className="split">
          <div className="left">
            <div className="steps">
              <div className="step">
                <h3>Find the Value of Your Home</h3>
                <p>
                  Through the Comparative Market Analysis, we can evaluate the prices of properties similar to yours that have recently sold in your area. This analysis will give you a better idea of your property's market value, one of the first - and essential! - steps as you prepare to sell your home. All it takes is a few quick minutes to complete and submit the form below. Then let my system do the work for you! We'll contact you as soon as we have the results.
                </p>
              </div>
            </div>

            <img src={main} />
          </div>

          <div className="right">
            <GeneralContactForm />
          </div>
        </div>

        <br/>
        <br/>
        <br/>
      </div>
    </div>
  </div>
);

export default Evaluation;
